import { apiRequest } from '@/lib/api-client';
import type { Assignment, BrandSettings, BusinessModel, Project } from './types';

const base = (orgId: string) => `/api/v1/organizations/${orgId}/projects`;

export const projectsApi = {
  list: (orgId: string) => apiRequest<Project[]>(base(orgId)),

  create: (orgId: string, body: { name: string; businessModel?: BusinessModel }) =>
    apiRequest<Project>(base(orgId), { method: 'POST', body }),

  get: (orgId: string, projectId: string) => apiRequest<Project>(`${base(orgId)}/${projectId}`),

  update: (orgId: string, projectId: string, body: { name: string }) =>
    apiRequest<Project>(`${base(orgId)}/${projectId}`, { method: 'PATCH', body }),

  updateBrand: (orgId: string, projectId: string, body: Partial<BrandSettings>) =>
    apiRequest<Project>(`${base(orgId)}/${projectId}/brand`, { method: 'PATCH', body }),

  remove: (orgId: string, projectId: string) =>
    apiRequest<{ deleted: boolean }>(`${base(orgId)}/${projectId}`, { method: 'DELETE' }),

  listAssignments: (orgId: string, projectId: string) =>
    apiRequest<Assignment[]>(`${base(orgId)}/${projectId}/assignments`),

  assign: (orgId: string, projectId: string, userId: string) =>
    apiRequest<{ assigned: boolean }>(`${base(orgId)}/${projectId}/assignments/${userId}`, {
      method: 'PUT',
    }),

  unassign: (orgId: string, projectId: string, userId: string) =>
    apiRequest<{ assigned: boolean }>(`${base(orgId)}/${projectId}/assignments/${userId}`, {
      method: 'DELETE',
    }),
};
